import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';

import { formatCostString } from '_utils/helpers/getCostEstimate';

import {
  FeeWrapper,
  FeeTitle,
  FeeDescription,
  TextWrapper,
  CostWrapper,
  Cost,
  CostModifier,
  ContentTab,
  ContentTabPrintTitle
} from './StyledCostAndFees';

const ContentTabs = ({ tabs, currentTabIndex }) => tabs.map((tab, i) => (
      <ContentTab
        className={i === currentTabIndex ? '' : 'is-hidden'}
        key={`content-${tab.id}`}
        id={`${tab.title.value}-${tab.id}-content`}
        role="tabpanel"
        aria-labelledby={`${tab.title.value}-${tab.id}-tab`}
      >
        <ContentTabPrintTitle>{tab.title.value}</ContentTabPrintTitle>

        {tab.costConditions.map(({ title, description, cost, costModifier, id }) => {
          const hasCost = cost?.value;

          return (
            <FeeWrapper key={id}>
              <TextWrapper>
                <FeeTitle>
                  <Text field={title} />
                </FeeTitle>

                {description?.value && (
                  <FeeDescription>
                    <Text field={description} />
                  </FeeDescription>
                )}
              </TextWrapper>
              <CostWrapper>
                {hasCost && <Cost>{formatCostString(cost.value)}</Cost>}

                {Boolean(hasCost && costModifier?.value) && (
                  <CostModifier>
                    <Text field={costModifier} />
                  </CostModifier>
                )}
              </CostWrapper>
            </FeeWrapper>
          );
        })}
      </ContentTab>
    ));

export default ContentTabs;
